(() => {
  if (customElements.get('sf-learning-search')) return;
  const normalise = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const compact = value => normalise(value).replace(/\s/g, '');
  const safeImage = value => /^(https:\/\/|\/\/|\/cdn\/)/.test(value || '');
  const pageHandles = {
  "sf-acropora-care": "acropora-care-guide",
  "sf-aefw": "acropora-eating-flatworm",
  "sf-aiptasia-majanos": "aiptasia-majano-anemones",
  "sf-algae-ids": "algae-ids",
  "sf-algae-ids-all-page-2": "algae-ids-page-2",
  "sf-algae-ids-all-page-3": "algae-ids-page-3",
  "sf-beginner-reefing": "brand-new-to-reefing",
  "sf-bubble-tip-anemone-care": "bubble-tip-anemone-care-guide",
  "sf-cleanup-crew": "cleanup-crew",
  "sf-cleanup-crew-all-page-2": "cleanup-crew-page-2",
  "sf-cleanup-crew-all-page-3": "cleanup-crew-page-3",
  "sf-copepods": "acropora-parasitic-copepods",
  "sf-drupella": "drupella-coral-eating-snails",
  "sf-eefw": "euphyllia-eating-flatworms",
  "sf-encrusters-lps-care": "encrusters-other-lps-care-guide",
  "sf-euphyllia-care": "euphyllia-care-guide",
  "sf-goniopora-care": "goniopora-alveopora-care-guide",
  "sf-goniopora-nudibranchs": "goniopora-eating-nudibranchs",
  "sf-hitchhiker-ids": "reef-tank-hitchhiker-identification",
  "sf-hitchhiker-ids-all-page-2": "reef-tank-hitchhiker-identification-page-2",
  "sf-hitchhiker-ids-all-page-3": "reef-tank-hitchhiker-identification-page-3",
  "sf-hitchhiker-ids-all-page-4": "reef-tank-hitchhiker-identification-page-4",
  "sf-hitchhiker-ids-all-page-5": "reef-tank-hitchhiker-identification-page-5",
  "sf-montipora-nudibranchs": "montipora-eating-nudibranchs",
  "sf-new-aefw": "new-acropora-eating-flatworm",
  "sf-pests-problems": "pests-problems",
  "sf-sea-spiders": "reef-tank-sea-spiders",
  "sf-species-guides": "species-care-guides",
  "sf-sps-care": "non-acropora-sps-coral-care-guide",
  "sf-zoanthid-nudibranchs": "zoanthid-eating-nudibranchs"
};
  let indexPromise;
  const loadIndex = root => {
    if (indexPromise) return indexPromise;
    const url = new URL(root || '/', location.origin);
    url.searchParams.set('view','sf-learning-data');
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id',preview);
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(),10000);
    indexPromise = fetch(url.href,{credentials:'same-origin',signal:controller.signal})
      .then(response => { if (!response.ok) throw new Error('Search unavailable'); return response.text(); })
      .then(html => {
        const element = new DOMParser().parseFromString(html,'text/html').querySelector('[data-sf-learning-index]');
        if (!element) throw new Error('Search unavailable');
        return JSON.parse(element.textContent).map(e => ({...e,
          name:normalise(e.title),scientific:normalise(e.latin),aliasesNormal:normalise(e.aliases),
          body:normalise(e.keywords),compactName:compact(e.title+' '+e.latin+' '+e.aliases)}));
      }).catch(error => { indexPromise = undefined; throw error; }).finally(() => clearTimeout(timeout));
    return indexPromise;
  };
  class LearningSearch extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      try {
        this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
        for (const key of Object.keys(this.labels)) this.labels[key] = this.labels[key].replace(/&amp;/g, '&');
      } catch (_) { return; }
      this.ready = true;
      this.input = this.querySelector('input'); this.scope = this.querySelector('select');
      this.scope.value = this.dataset.scope || 'all';
      this.results = this.querySelector('.sf-learning-search__results'); this.list = this.querySelector('ul');
      this.status = this.querySelector('[role="status"]'); this.clear = this.querySelector('[data-clear]');
      this.more = this.querySelector('[data-more]'); this.broaden = this.querySelector('[data-broaden]');
      this.limit = 8;
      this.input.addEventListener('input', () => { clearTimeout(this.timer); this.timer = setTimeout(() => { this.limit = 8; this.search(); }, 120); });
      this.scope.addEventListener('change', () => { this.limit = 8; this.search(); });
      this.clear.addEventListener('click', () => this.reset());
      this.more.addEventListener('click', () => { const previous = this.limit; this.limit += 8; this.search(); this.list.children[previous]?.querySelector('a')?.focus(); });
      this.broaden.addEventListener('click', () => { this.scope.value = 'all'; this.limit = 8; this.search(); this.input.focus(); });
      this.querySelector('form').addEventListener('submit', async e => { e.preventDefault(); clearTimeout(this.timer); await this.search(); this.list.querySelector('a')?.focus(); });
      this.addEventListener('keydown', e => { if (e.key === 'Escape') { e.preventDefault(); this.reset(); } });
      this.input.addEventListener('keydown', e => { if (e.key === 'ArrowDown' && !this.results.hidden) { e.preventDefault(); this.list.querySelector('a')?.focus(); } });
      this.hidden = false;
      if (this.input.value) this.search();
    }
    reset() { clearTimeout(this.timer); this.input.value = ''; this.limit = 8; this.search(); this.input.focus(); }
    score(entry, query) {
      const terms = query.split(' ').map(t => t.length > 3 ? t.replace(/s$/, '') : t);
      const hay = entry.name + ' ' + entry.scientific + ' ' + entry.aliasesNormal + ' ' + entry.body;
      const direct = entry.compactName.includes(query.replace(/\s/g, ''));
      if (!direct && !terms.every(t => hay.split(' ').some(word => word.startsWith(t)))) return 0;
      return (entry.name === query ? 1000 : entry.name.includes(query) ? 500 : 0)
        + (entry.scientific.includes(query) ? 350 : 0) + (entry.aliasesNormal.includes(query) ? 300 : 0)
        + (direct ? 150 : 0) + terms.reduce((n,t) => n + (entry.name.includes(t) ? 40 : entry.scientific.includes(t) ? 30 : 1), 0);
    }
    async search() {
      const generation = this.generation = (this.generation || 0) + 1;
      const q = normalise(this.input.value);
      this.clear.hidden = !this.input.value; this.results.hidden = !this.input.value;
      this.list.replaceChildren(); this.more.hidden = true; this.broaden.hidden = true;
      if (!q || q.length < 2) { this.status.textContent = this.input.value ? this.labels.minimum : ''; return; }
      if (!this.entries) {
        this.status.textContent = this.labels.loading;
        try { this.entries = await loadIndex(this.dataset.root); }
        catch (_) { if (generation === this.generation) this.status.textContent = this.labels.error; return; }
        if (generation !== this.generation) return;
      }
      const matches = this.entries.filter(e => this.scope.value === 'all' || e.group === this.scope.value)
        .map(e => ({entry:e, score:this.score(e,q)})).filter(e => e.score > 0)
        .sort((a,b) => b.score - a.score || a.entry.title.localeCompare(b.entry.title));
      this.status.textContent = matches.length ? this.labels.count.replace('[shown]', Math.min(matches.length,this.limit)).replace('[total]',matches.length) : this.labels.empty;
      matches.slice(0,this.limit).forEach(({entry}) => this.list.append(this.result(entry)));
      this.more.hidden = matches.length <= this.limit;
      this.broaden.hidden = this.scope.value === 'all';
    }
    result(entry) {
      const li = document.createElement('li'), link = document.createElement('a');
      const url = new URL(this.dataset.root || '/', location.origin);
      if (pageHandles[entry.view]) url.pathname = url.pathname.replace(/\/?$/, '/') + 'pages/' + pageHandles[entry.view];
      else url.searchParams.set('view',entry.view);
      url.hash = entry.anchor || '';
      // Preview cookies normally preserve the selected theme; retain an explicit ID too when present.
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id',preview);
      link.href = url.href; link.className = 'sf-learning-search__result';
      if (safeImage(entry.image)) { const image = document.createElement('img'); image.src = entry.image; image.alt = ''; image.width = 54; image.height = 54; image.loading = 'eager'; image.decoding = 'async'; image.addEventListener('error',()=>image.remove(),{once:true}); link.append(image); }
      const copy = document.createElement('span'); copy.className = 'sf-learning-search__copy';
      const title = document.createElement('span'); title.className = 'sf-learning-search__title'; title.textContent = entry.title;
      const meta = document.createElement('span'); meta.className = 'sf-learning-search__meta'; meta.textContent = [this.labels[entry.group],entry.latin].filter(Boolean).join(' · ');
      copy.append(title,meta); const arrow = document.createElement('span'); arrow.className = 'sf-learning-search__arrow'; arrow.textContent = '↗'; arrow.setAttribute('aria-hidden','true');
      link.append(copy,arrow); li.append(link);
      if (entry.credit && entry.image) {
        const details = document.createElement('details'); details.className = 'sf-learning-search__credit';
        const summary = document.createElement('summary'); summary.textContent = this.labels.credit;
        const credit = document.createElement('p'); credit.textContent = entry.credit;
        details.append(summary,credit);
        for (const [key,label] of [['source','source'],['licence','licence']]) {
          if (!/^https:\/\//.test(entry[key] || '')) continue;
          const a = document.createElement('a'); a.href = entry[key]; a.textContent = this.labels[label]; a.target = '_blank'; a.rel = 'noopener'; details.append(a);
        }
        li.append(details);
      }
      return li;
    }
  }
  customElements.define('sf-learning-search',LearningSearch);
})();
